<template>
    <div class="col-12 col-sm-6 col-md-5 p-0" style="min-height: 500px;">
        <div class="border bg-light p-3">
            <div class="d-inline-flex" :style="[selected ? { 'display':'none !important' } : {  }]">

                <div class="mr-2"><span class="font-icons icons-location text-secondary icon-small-pdv"></span>
                    {{ __('messages.state') }}:
                </div>
                <pdv-dropdown :states="states" :dispatch="dispatch" @selectState="filterBranches($event)"></pdv-dropdown>
            </div>

            <div class="btnTertiary" v-if="selected" @click="back()">

                <span class="font-icons icons-arrow-back cursor-pointer"></span>
                <span>{{ __('messages.back_to_list') }}</span>

            </div>
        </div>

        <div class="container-list">
            <ul class="list-pdv" :style="[selected ? { 'display':'none !important' } : {  }]">
                <li v-for="branch in list" class="border d-flex align-items-center cursor-pointer justify-content-between"
                    @click="selectItem(branch)">
                    <div>
                        <strong>{{ branch.displayNameShort }}</strong>
                        <p>
                            <span v-html="branch.address"></span>
                            <br v-if="branch.whatsAppLink" />
                            <a v-if="branch.whatsAppLink" class="wa-contact-link" :href="branch.whatsAppLink" target="_blank" rel="noopener noreferrer">
                                <i class="icons-whatsapp font-green"></i>
                                <span class="font-green">{{ __('messages.wa_contact') }}</span>
                            </a>
                        </p>
                    </div>
                    <div class="pdv-rotate">
                        <span class="font-icons icons-chevron-up"></span>
                    </div>
                </li>
            </ul>

            <pdv-card v-if="selected" :dispatch="dispatch" :branch="selected" @closed="back()"></pdv-card>
        </div>

    </div>
</template>

<script>

const fn = window.__pt.fn;

export default {
    props: {
        branches: Array,
        states: Array,
        dispatch: Object,
        marker: Object
    },
    data() {
        return {
            selected: null,
            list: [],
            culture: window.__pt.cultureData,
            historypath: window.location.pathname
        };
    },
    watch: {
        marker: function () {
            this.selectItem(this.marker);
        }
    },
    mounted: function () {
        this.list = this.branches;
        if(this.states.length === 0) {
            this.selectItem(this.branches[0]);
        }
    },
    methods: {
        selectItem(item) {
            this.historypath = window.location.pathname;
            this.selected = item;

            if (window.screen.width <= 576) {
                document.body.style.overflow = 'hidden';
                window.scrollTo(0, 0);
            }

            if (item.latitude !== "") {
                this.$emit('selectPlace', item);
            }

            window.history.pushState('', '', "/" + this.culture.cultureCode + window.i18n.messages.path + item.uri);
        },
        filterBranches(e) {
            this.list = this.branches;
            if(e) {
                this.list = this.list.filter(branch => branch.stateName === e);
            }
            this.$emit("changeState", this.list)
        },
        back() {
            this.selected = null;
            this.$emit('selectPlace', null);
            window.history.pushState('', '', this.historypath);
        }
    }
};
</script>
    